import "./Spinner.css";

function Spinner() {
  return (
    <div className="pm-spinner-wrapper">
      <div className="pm-spinner" />
    </div>
  );
}

export default Spinner;